<style lang="scss" scoped>
.link-input-form {
  background: #eee;
  padding: 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.input-url {
  font-size: 13px;
  margin: 0 0 10px;

  a {
    text-decoration: underline;
    color: #000;
    font-size: 14px;
    margin-bottom: 10px;
  }
}
.description {
  font-size: 12px;
  color: #676767;
  margin-top: 10px;
  line-height: 1.3rem;
}

.checkbox-group {
  display: flex;
  align-items: center;

  &__input {
    margin-right: 12px;
  }
}
.referer-site {
  font-size: 12px;
  color: gray;
  margin-top: 10px;
}
</style>

<template>
  <div class="link-input">
    <div class="link-input-form" v-if="isEditing">
      <link-preview
        v-if="previewable"
        :title="title"
        :description="description"
        :url="url"
        v-bind="{ image_url: image_url }"
      />
      <h2>リンク</h2>
      <div class="form-group">
        <input
          class="form-control"
          type="text"
          v-model="url"
          placeholder="リンク先のURL"
        />
        <p class="small">URLを入れてチェックを押してください</p>
      </div>
      <div class="form-group">
        <input
          class="form-control"
          type="text"
          v-model="title"
          placeholder="リンク先タイトル"
        />
      </div>
      <div class="form-group">
        <input
          class="form-control"
          type="text"
          v-model="description"
          placeholder="リンクの説明"
        />
      </div>
      <div class="form-group">
        <label class="checkbox-group">
          <input
            class="checkbox-group__input"
            type="checkbox"
            v-model="force_follow"
          />
          <span>nofollowを付与しない</span>
        </label>
      </div>
      <div class="btn-group">
        <a @click="check()" class="btn-green">チェック</a>
        <a @click="onEndEdit()" class="btn-green">追加</a>
        <a class="btn-normal" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="link-input-preview input-preview" v-else>
      <link-preview
        v-if="previewable"
        :title="title"
        :description="description"
        :url="url"
        v-bind="{ image_url: image_url }"
      />
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
import linkPreview from './link-preview.vue';

export default {
  computed: {
    bodyJSON() {
      return {
        value: {
          url: this.url,
          title: this.title,
          description: this.description,
          image_url: this.image_url,
          force_follow: this.force_follow,
        },
        action: 'link',
      };
    },
    valid() {
      return this.url.length && this.title.length && this.description.length;
    },
    validURL() {
      return this.url.length && /^(ftp|http|https):\/\/[^ "]+$/.test(this.url);
    },
    previewable() {
      return this.url.length && this.title.length;
    },
  },
  components: {
    'footer-menu': footerMenu,
    'link-preview': linkPreview,
  },
  mounted() {
    this.url = this.value.url;
    this.title = this.value.title;
    this.description = this.value.description;
    this.image_url = this.value.image_url;
    this.force_follow = this.value.force_follow;
  },
  methods: {
    check() {
      if (!this.validURL) {
        alert('不正なURLです。');
        return false;
      }
      $.ajax({
        url: '/api/embed',
        dataType: 'json',
        type: 'GET',
        cache: false,
        data: {
          url: this.url,
        },
      })
        .then((data) => {
          this.description = data.summary || '';
          this.title = data.title || '';
          this.image_url = data.image_url || '';
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        const alertArray = [];
        if (!this.url.length) {
          alertArray.push('リンク先のURLを入力してください。');
        }
        if (!this.title.length) {
          alertArray.push('リンク先タイトルを入力してください。');
        }
        if (!this.description.length) {
          alertArray.push('リンクの説明を入力してください。');
        }
        alert(alertArray.join('\n'));
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  props: {
    index: Number,
    value: {},
    id: String,
  },
  data() {
    return {
      isEditing: false,
      url: '',
      title: '',
      description: '',
      image_url: '',
      force_follow: false,
    };
  },
};
</script>
